import React, { useContext } from 'react'
import { Text } from '@chakra-ui/react'
import { buildAttributeValue } from '../../../selectors/attributes'
import { filterExcluded } from './AttributesList'
import { AttributeRow } from './AttributeRow'
import { TranslateContext } from 'client/common/translator'

export const GroupedAttributesList = ({ attributes, pimAttributesTranslations, lang }) => {
  const t = useContext(TranslateContext)
  const clustered = toClustered(attributes)

  return Object.keys(clustered).map((cluster, j) => {
    return (
      <li key={`li-${cluster}`} className='attr-section'>
        <Text as='b' mb='4' display='block'>
          {t(`cluster_${cluster}`)}
        </Text>
        <dl>
          {clustered[cluster].map((attr, i) => {
            const value = buildAttributeValue(attr, lang)

            const displayName = attr.displayName
            const description = pimAttributesTranslations[`pim.attributes.${attr.name}.description`]
            return (
              <AttributeRow
                key={`dt-${displayName}${value}-${i}`}
                index={i}
                displayName={displayName}
                description={description}
                value={value}
              />
            )
          })}
        </dl>
      </li>
    )
  })
}

function toClustered(attributes) {
  const result = {}
  filterExcluded(attributes)
    .map(([key, value]) => ({
      name: key,
      ...value
    }))
    .filter(it => it.cluster)
    .forEach(it => {
      if (!result[it.cluster]) result[it.cluster] = []
      result[it.cluster].push(it)
    })
  return result
}
